<main class="login" aria-labelledby="login-title">
  <section class="login__panel">
    <div class="login__mark" aria-hidden="true"><span>MC</span></div>
    <p class="login__eyebrow">MERCURE · COLLECT AI</p>
    <h1 id="login-title">Ouvrir votre espace</h1>
    <p class="login__intro">Pilotez vos dossiers de recouvrement avec une vue claire, actionnable et sécurisée.</p>

    <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <label for="username">Identifiant</label>
      <input id="username" type="text" formControlName="username" autocomplete="username" placeholder="Votre identifiant" />
      @if (form.controls.username.touched && form.controls.username.invalid) { <small>Identifiant requis.</small> }
      <label for="password">Mot de passe</label>
      <input id="password" type="password" formControlName="password" autocomplete="current-password" placeholder="Votre mot de passe" />
      @if (form.controls.password.touched && form.controls.password.invalid) { <small>Mot de passe requis.</small> }
      @if (error()) { <p class="login__error" role="alert">{{ error() }}</p> }
      <button type="submit" [disabled]="submitting()">{{ submitting() ? 'Connexion…' : 'Se connecter' }} <span aria-hidden="true">→</span></button>
    </form>
    <p class="login__foot">Accès réservé aux équipes MERCURE</p>
  </section>
  <aside class="login__aside" aria-label="Informations MERCURE">
    <p class="login__aside-code">01 / COLLECTION INTELLIGENCE</p>
    <h2>Chaque dossier mérite<br /><em>la bonne action.</em></h2>
    <div class="login__aside-line"></div>
    <p>Une orchestration métier pensée pour les agents, les superviseurs et les décideurs.</p>
  </aside>
</main>
